import { render, staticRenderFns } from "./SectionFeature.vue?vue&type=template&id=2012e181&"
import script from "./SectionFeature.vue?vue&type=script&lang=js&"
export * from "./SectionFeature.vue?vue&type=script&lang=js&"
import style0 from "./SectionFeature.vue?vue&type=style&index=0&id=2012e181&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports